/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Schema for updating a tutorial.
 * @export
 * @interface TutorialUpdate
 */
export interface TutorialUpdate {
    /**
     * 
     * @type {string}
     * @memberof TutorialUpdate
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialUpdate
     */
    description?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof TutorialUpdate
     */
    is_public?: boolean | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TutorialUpdate
     */
    organization_ids?: Array<string> | null;
    /**
     * 
     * @type {boolean}
     * @memberof TutorialUpdate
     */
    deleted?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof TutorialUpdate
     */
    complexity?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialUpdate
     */
    language?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TutorialUpdate
     */
    field?: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof TutorialUpdate
     */
    tag_ids?: Array<string> | null;
}

/**
 * Check if a given object implements the TutorialUpdate interface.
 */
export function instanceOfTutorialUpdate(value: object): value is TutorialUpdate {
    return true;
}

export function TutorialUpdateFromJSON(json: any): TutorialUpdate {
    return TutorialUpdateFromJSONTyped(json, false);
}

export function TutorialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): TutorialUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'is_public': json['is_public'] == null ? undefined : json['is_public'],
        'organization_ids': json['organization_ids'] == null ? undefined : json['organization_ids'],
        'deleted': json['deleted'] == null ? undefined : json['deleted'],
        'complexity': json['complexity'] == null ? undefined : json['complexity'],
        'language': json['language'] == null ? undefined : json['language'],
        'field': json['field'] == null ? undefined : json['field'],
        'tag_ids': json['tag_ids'] == null ? undefined : json['tag_ids'],
    };
}

export function TutorialUpdateToJSON(json: any): TutorialUpdate {
    return TutorialUpdateToJSONTyped(json, false);
}

export function TutorialUpdateToJSONTyped(value?: TutorialUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'description': value['description'],
        'is_public': value['is_public'],
        'organization_ids': value['organization_ids'],
        'deleted': value['deleted'],
        'complexity': value['complexity'],
        'language': value['language'],
        'field': value['field'],
        'tag_ids': value['tag_ids'],
    };
}

